import { GET_LEADS } from "./constants";

const initialState = {
  getLeads: {
    count: 0,
    rows: [],
  },
};
export default (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case GET_LEADS:
      return { ...state, getLeads: data };
    default:
      return state;
  }
};
